var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "JumpTemplate" },
    [
      _c(
        "div",
        {
          ref: "courseSubShow",
          staticClass: "JumpTLeft",
          style: _vm.myIframeStyle
        },
        [
          _c(
            "div",
            {
              ref: "topIframe",
              staticClass: "topIframe",
              style: _vm.topIframe
            },
            [
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.iframeDrag,
                    expression: "iframeDrag"
                  }
                ],
                staticClass: "iframe_mask"
              }),
              _vm._v(" "),
              _c("iframe", {
                attrs: {
                  width: "100%",
                  height: "100%",
                  src: _vm.topIframeUrl,
                  frameborder: "0"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.bottomIframeUrl,
                expression: "bottomIframeUrl"
              }
            ],
            staticClass: "iframeDrapLineTB",
            on: {
              mousedown: function($event) {
                $event.stopPropagation()
                return _vm.iframeLineMoveTB($event)
              }
            }
          }),
          _vm._v(" "),
          _vm.bottomIframeUrl
            ? _c(
                "div",
                { staticClass: "bottomIframe" },
                [
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.iframeDrag,
                        expression: "iframeDrag"
                      }
                    ],
                    staticClass: "iframe_mask"
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "closeChildrenIframe",
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.answerBoardThreeScreen()
                        }
                      }
                    },
                    [_vm._v("关闭\n      ")]
                  ),
                  _vm._v(" "),
                  _c("iframe", {
                    attrs: {
                      width: "100%",
                      height: "100%",
                      src: _vm.bottomIframeUrl,
                      frameborder: "0"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.diaLayout === "左右"
        ? _c(
            "div",
            {
              staticClass: "code_line",
              on: {
                mousedown: function($event) {
                  $event.stopPropagation()
                  return _vm.lineMove($event)
                }
              }
            },
            [
              _c("span", { staticClass: "code_line_icon" }, [
                _c(
                  "svg",
                  {
                    staticClass: "icon svg-icon",
                    staticStyle: { width: "20px", height: "13px" },
                    attrs: { "aria-hidden": "true" }
                  },
                  [_c("use", { attrs: { "xlink:href": "#icon-tuozhuai1" } })]
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "JumpTRight" }),
      _vm._v(" "),
      _vm.isSmall
        ? _c(
            "div",
            {
              directives: [{ name: "drag", rawName: "v-drag" }],
              ref: "dragIcon",
              staticClass: "dragIcon",
              style: _vm.dragIconStyle
            },
            [_c("i", { staticClass: "el-icon-copy-document" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          staticClass: "courseSubDialog",
          attrs: {
            "close-on-click-modal": false,
            modal: false,
            visible: _vm.dialogVisible,
            "show-close": false,
            customClass: "customHeight"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "span",
            { staticClass: "dia_span" },
            [
              _c("span", { staticStyle: { "font-size": "11px" } }, [
                _vm._v("字号：")
              ]),
              _vm._v(" "),
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.fontChange },
                  model: {
                    value: _vm.fontSize,
                    callback: function($$v) {
                      _vm.fontSize = $$v
                    },
                    expression: "fontSize"
                  }
                },
                [
                  _c("el-radio-button", { attrs: { label: "默认" } }),
                  _vm._v(" "),
                  _c("el-radio-button", { attrs: { label: "小号" } })
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticStyle: { "font-size": "11px" } }, [
                _vm._v("布局：")
              ]),
              _vm._v(" "),
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.layoutChange },
                  model: {
                    value: _vm.diaLayout,
                    callback: function($$v) {
                      _vm.diaLayout = $$v
                    },
                    expression: "diaLayout"
                  }
                },
                [
                  _c("el-radio-button", { attrs: { label: "浮窗" } }),
                  _vm._v(" "),
                  _c("el-radio-button", { attrs: { label: "左右" } })
                ],
                1
              ),
              _vm._v(" "),
              _vm.diaLayout === "浮窗"
                ? [
                    _vm.isMini
                      ? _c("i", {
                          staticClass: "small_icon el-icon-minus",
                          on: { click: _vm.small }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isHalf
                      ? _c("i", {
                          staticClass: "large_icon el-icon-copy-document",
                          on: { click: _vm.huanyuan }
                        })
                      : _c("i", {
                          staticClass: "large_icon el-icon-full-screen",
                          on: { click: _vm.large }
                        })
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("i", {
                directives: [
                  {
                    name: "bury",
                    rawName: "v-bury",
                    value: { route: _vm.$route, template: _vm.activeOne },
                    expression: "{ route: $route, template: activeOne }"
                  }
                ],
                staticClass: "el-icon-back",
                on: { click: _vm.back }
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "el-tabs",
            {
              staticStyle: { padding: "0 10px", height: "100%" },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: " 题 面 ", name: "first" } },
                [
                  _vm.activeOne.resourceType == 3
                    ? _c("div", {
                        staticClass: "editorShowArea ql-editor",
                        class: { font_size: _vm.changeFont },
                        staticStyle: { "user-select": "text" },
                        domProps: { innerHTML: _vm._s(_vm.activeOne.content) }
                      })
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _vm.isShowComponent()
                ? _c(
                    "el-tab-pane",
                    { attrs: { label: "答案展示", name: "second" } },
                    [
                      _c("my-component", {
                        attrs: {
                          companyCode: _vm.templateCode,
                          isShow:
                            _vm.userType == 0 ||
                            _vm.userType == 1 ||
                            (_vm.isBtn && !!_vm.activeOne.show) ||
                            _vm.scoreType === "dev",
                          optObject: _vm.optObject,
                          refresh: _vm.answerRefresh,
                          catalogId: _vm.catalogId,
                          courseType: _vm.courseType,
                          type: _vm.type,
                          myId: _vm.activeOne.id
                        },
                        on: { taskSubmit: _vm.taskSubmit }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                {
                  staticStyle: { height: "732px" },
                  attrs: { label: "附件", name: "third" }
                },
                [
                  _vm.questionEnclosure.length
                    ? _c(
                        "div",
                        { staticClass: "file_lists" },
                        _vm._l(_vm.questionEnclosure, function(item) {
                          return _c(
                            "div",
                            {
                              key: item.id,
                              staticClass: "file_item",
                              class: {
                                selected_item: _vm.selectedItem.id === item.id
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.handleSelectedItem(item)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(item.name) +
                                  "\n          "
                              )
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.questionEnclosure.length
                    ? _c("div", { staticClass: "file_look" }, [
                        _vm.selectedItem.id
                          ? _c("div", { staticClass: "selected_file_look" }, [
                              _c("iframe", {
                                attrs: {
                                  width: "100%",
                                  height: "100%",
                                  src: _vm.selectedFileUrl,
                                  frameborder: "0"
                                }
                              })
                            ])
                          : _vm._e()
                      ])
                    : _c("div", { staticClass: "file_empty" }, [
                        _vm._v("暂无数据")
                      ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "operations" },
            [
              _c("platform-btn", {
                attrs: {
                  type: _vm.type,
                  courseId: _vm.courseId,
                  classId: _vm.classId,
                  catalogId: _vm.catalogId,
                  listItem: _vm.activeOne,
                  myStation: _vm.myStation,
                  isChild: "",
                  buttonShowArr: _vm.platformName,
                  childrenBtn: _vm.childrenBtn
                },
                on: { platformJump: _vm.platformJump }
              }),
              _vm._v(" "),
              _vm.scoreType === "dev"
                ? _c(
                    "el-button",
                    {
                      staticClass: "btnStyle btnBlueStyle",
                      staticStyle: { "margin-left": "10px" },
                      on: {
                        click: _vm.answerCompareBtn,
                        dblclick: _vm.dblclick
                      }
                    },
                    [_vm._v("答案对比\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "btnStyle btnBlueStyle",
                  staticStyle: { "margin-left": "10px" },
                  on: { click: _vm.showFeedBack, dblclick: _vm.dblclick }
                },
                [_vm._v("意见反馈\n      ")]
              ),
              _vm._v(" "),
              _vm.isBtn
                ? _c(
                    "el-button",
                    {
                      staticClass: "btnStyle btnBlueStyle",
                      staticStyle: { "margin-left": "10px" },
                      on: { click: _vm.handleRefresh, dblclick: _vm.dblclick }
                    },
                    [_vm._v("任务提交\n      ")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "count_down_dialog",
          attrs: {
            top: "38vh",
            width: "422px",
            title: "提示",
            "show-close": false,
            "destroy-on-close": "",
            visible: _vm.innerVisible,
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _vm.isShowTeamWeight()
            ? _c(
                "div",
                { staticClass: "count_down_main" },
                [
                  _vm.teamWeight >= 0
                    ? [
                        _c("p", [_vm._v("本题总分:10")]),
                        _vm._v(" "),
                        Number(_vm.type) === 3
                          ? _c("p", [
                              _vm._v(
                                "\n          本题本岗位总分:" +
                                  _vm._s(Number(_vm.rolesWeight)) +
                                  "\n        "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        Number(_vm.type) === 3
                          ? _c("p", [
                              _vm._v(
                                "本岗位得分:" + _vm._s(Number(_vm.teamWeight))
                              )
                            ])
                          : _c("p", [
                              _vm._v(
                                "本题得分:" + _vm._s(Number(_vm.teamWeight))
                              )
                            ])
                      ]
                    : Number(_vm.type) === 3 && _vm.teamWeight == -2
                    ? _c("div", { staticClass: "teamWeightMsg" }, [
                        _vm._v("\n        本任务对当前岗位不做考核\n      ")
                      ])
                    : _vm.teamWeight == -3
                    ? _c("div", { staticClass: "teamWeightMsg" }, [
                        _vm._v("\n        资源加载中，请稍后再试。\n      ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "teamWeightMsg" }, [
                    _vm._v("\n        任务提交成功！\n      ")
                  ])
                ],
                2
              )
            : _c("div", { staticClass: "teamWeightMsg" }, [
                _vm._v("\n      任务提交成功！\n    ")
              ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.back } },
                [_vm._v("返回上一页")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.innerVisible = false
                    }
                  }
                },
                [_vm._v("留在此页\n      ")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "feed_back",
          attrs: {
            title: "意见反馈",
            visible: _vm.feedBackShow,
            width: "650px",
            center: "",
            "custom-class": "feedBack",
            modal: false,
            "destroy-on-close": "",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.feedBackShow = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "from_cont" },
            [
              _c(
                "el-form",
                {
                  ref: "feedForm",
                  attrs: {
                    inline: "",
                    model: _vm.feedForm,
                    rules: _vm.feedRules,
                    "label-position": "left",
                    "label-width": "100%"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "问题类型", prop: "questionType" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.feedForm.questionType,
                            callback: function($$v) {
                              _vm.$set(_vm.feedForm, "questionType", $$v)
                            },
                            expression: "feedForm.questionType"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: "试题评分" } }),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: "业务系统" } }),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: "教学平台" } }),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: "产品建议" } }),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: "其他" } })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.feedForm.questionType == "试题评分"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "试题编号", prop: "questionCode" } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "20" },
                            model: {
                              value: _vm.feedForm.questionCode,
                              callback: function($$v) {
                                _vm.$set(_vm.feedForm, "questionCode", $$v)
                              },
                              expression: "feedForm.questionCode"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("（例如：TY-SS-0703）")])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "问题描述", prop: "questionDescribe" } },
                    [
                      _c("editor", {
                        model: {
                          value: _vm.feedForm.questionDescribe,
                          callback: function($$v) {
                            _vm.$set(_vm.feedForm, "questionDescribe", $$v)
                          },
                          expression: "feedForm.questionDescribe"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "span",
                {
                  staticClass: "zl_button zl_whiteButton",
                  on: {
                    click: function($event) {
                      return _vm.handleFeedBack(false, "feedForm")
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "zl_button zl_blueButton",
                  on: {
                    click: function($event) {
                      return _vm.handleFeedBack(true, "feedForm")
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "feed_back",
          attrs: {
            title: "意见反馈",
            visible: _vm.feedBackCloseShow,
            width: "580px",
            center: "",
            "custom-class": "feedBack",
            modal: false,
            "close-on-click-modal": false,
            "destroy-on-close": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.feedBackCloseShow = $event
            }
          }
        },
        [
          _c("div", { staticClass: "close_cont" }, [
            _c("div", { staticClass: "title" }, [
              _c("p", [_vm._v("提交成功")]),
              _vm._v(" "),
              _c("p", [_vm._v("感谢您的反馈，我们会尽快解决您的问题")])
            ])
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "span",
                {
                  staticClass: "zl_button zl_whiteButton",
                  on: {
                    click: function($event) {
                      _vm.feedBackCloseShow = false
                    }
                  }
                },
                [_vm._v("关 闭")]
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23be06f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23be06f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/JumpTemplate.vue
// module id = null
// module chunks = 